export default __webpack_public_path__ + "static/media/shortly.88b588eb.png";